
import { computed, defineComponent } from "vue";
import zxcvbn from "zxcvbn";

export default defineComponent({
  props: {
    password: {
      type: String,
      required: false,
      default: "",
    },
  },
  setup(props) {
    const passwordStrength = {
      0: "Too short, Please make it stronger to proceed.",
      1: "Weak, Please make it stronger to proceed.",
      2: "Mediocre! Please make it stronger to proceed.",
      3: "Good",
      4: "Strong",
    };
    const strengthScore = computed(() => zxcvbn(props.password).score);

    const strengthLevel = computed(() => {
      const score = strengthScore.value;
      return score ? `level-${score}` : "level-0";
    });

    return {
      passwordStrength,
      strengthLevel,
      strengthScore,
    };
  },
});
